<template>
    <div id="contenedor-eliminar-catalogo-auditoria-etiqueta">
      <v-card>
        <v-card-title class="secondary--text"> Eliminar auditoria etiqueta </v-card-title>
        <v-card-text>
          <span class="secondary--text">
            ¿Desea eliminar la etiqueta"{{catalogoAuditoriaEtiquetaEliminar.descripcion}}"?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixEliminarCatalogoAuditoriaEtiqueta"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </div>
  </template>

<script>
import mixCatalogoAuditoriasEtiquetas from './mixCatalogoAuditoriasEtiquetas';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogoAuditoriasEtiquetasEliminar',
  mixins: [mixCatalogoAuditoriasEtiquetas],
  props: {
    catalogoAuditoriaEtiquetaEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

  <style>
  </style>
